export const formatErrorMessage = (msg: string | null) => {
  if (msg) {
    const a = msg.indexOf("Order Release Id:");
    const b = msg.indexOf("Errors:");
    return msg.substring(0, a).toUpperCase() + "-- " + msg.substring(b, msg.length);
  }
};

export const isAirFreightError = (msg: string | null) => {
  if (!msg) {
    return false;
  }
  // Accpac only returns free text errors, so we match on its wording. "airfreightItem" appears
  // only when an item can't fit in the air freight boxes, the one case road freight can fix.
  // Any other error (SSL, address, Accpac/system) gets the generic friendly message instead.
  return msg.includes("airfreightItem");
};
